import { useState } from "react";
import useValidation from "./useValidation";

const useInputState = (OPTIONAL_VALUE = "") => {
  const state = useState({
    invalid: false,
    errorMessage: "",
    value: OPTIONAL_VALUE,
  });
  const ref = useValidation();
  return [...state, ...ref];
};

export default useInputState;
